import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70c5dcb7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sidebar-body grid no-gutter -ml-3 -mr-3 pt-2 pb-2 text-black20" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 bg-gray" }, "名前", -1))
const _hoisted_3 = { class: "col-9 flex justify-content-between pt-0 pb-0" }
const _hoisted_4 = { class: "flex align-items-center justify-content-center" }
const _hoisted_5 = { class: "h-2rem inline-block text-base" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = { class: "flex align-items-center justify-content-center mr-3" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 bg-gray" }, "フリガナ", -1))
const _hoisted_9 = { class: "col-9" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 bg-gray" }, "カルテNo.", -1))
const _hoisted_11 = { class: "col-9" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 bg-gray" }, "電話番号", -1))
const _hoisted_13 = { class: "col-9" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 bg-gray" }, "予約日", -1))
const _hoisted_15 = { class: "col-9" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 bg-gray" }, "リクエスト日時", -1))
const _hoisted_17 = { class: "col-9" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 bg-gray" }, "メニュー名", -1))
const _hoisted_19 = {
  class: "col-9",
  style: {"white-space":"pre-line"}
}
const _hoisted_20 = {
  key: 2,
  class: "col-3 bg-gray"
}
const _hoisted_21 = {
  key: 3,
  class: "col-9"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 bg-gray" }, "オプションメニュー", -1))
const _hoisted_23 = { class: "col-9" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 bg-gray" }, "金額", -1))
const _hoisted_25 = { class: "col-9" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 bg-gray" }, "指名料", -1))
const _hoisted_27 = { class: "col-9" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 bg-gray" }, "担当施術者", -1))
const _hoisted_29 = { class: "col-9" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 bg-gray" }, "予約メモ", -1))
const _hoisted_31 = { class: "col-9" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 bg-gray" }, "気になる部位・お悩みの症状", -1))
const _hoisted_33 = { class: "col-9 mt-2" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 bg-gray" }, "特記事項", -1))
const _hoisted_35 = {
  class: "col-9 mt-2 overflow-auto",
  style: {"max-height":"30vh"}
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 bg-gray" }, "希望日時", -1))
const _hoisted_37 = { class: "col-9" }
const _hoisted_38 = ["for"]
const _hoisted_39 = {
  key: 0,
  class: "icon-lms icon-lms_rad-chosen radio-icon"
}
const _hoisted_40 = {
  key: 1,
  class: "icon-lms icon-lms_radio radio-icon"
}
const _hoisted_41 = {
  key: 0,
  class: "footer text-black20"
}
const _hoisted_42 = {
  key: 0,
  class: "flex align-items-center justify-content-start"
}
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "h-2rem inline-block text-base" }, "来店ステータスタグ管理", -1))
const _hoisted_44 = [
  _hoisted_43
]
const _hoisted_45 = {
  key: 1,
  class: "field flex flex-wrap mb-4 px-3"
}
const _hoisted_46 = {
  key: 1,
  class: "w-100 flex justify-content-center"
}
const _hoisted_47 = {
  key: 2,
  class: "grid mb-4 justify-content-evenly"
}
const _hoisted_48 = {
  key: 0,
  class: "col-5 px-0"
}
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-5 px-0" }, null, -1))
const _hoisted_50 = { key: 3 }
const _hoisted_51 = {
  key: 0,
  class: "flex align-items-center justify-content-start"
}
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "h-2rem inline-block text-base" }, "予約情報変更", -1))
const _hoisted_53 = [
  _hoisted_52
]
const _hoisted_54 = { class: "grid mb-4 justify-content-evenly" }
const _hoisted_55 = {
  key: 0,
  class: "col-5 px-0"
}
const _hoisted_56 = { class: "col-5 px-0" }
const _hoisted_57 = { class: "d-flex align-items-center" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/images/warning-logo.png",
  alt: "Warning Logo",
  class: "warning-logo mr-4 ml-2"
}, null, -1))
const _hoisted_59 = { class: "text-red-600" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p-dialog-content" }, "※ ステータス確定後にステータスの変更を行うことはできません。", -1))
const _hoisted_61 = { class: "grid mt-5 mb-5 justify-content-center" }
const _hoisted_62 = { class: "field-radiobutton md:mr-1" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "only-this",
  class: "ml-2"
}, "今回の予約", -1))
const _hoisted_64 = { class: "field-radiobutton md:mr-1" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "this_and_following",
  class: "ml-2"
}, "今回と次回以降の予約", -1))
const _hoisted_66 = { class: "col-12 flex justify-content-center mt-2" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/images/warning-logo.png",
    alt: "Warning Logo",
    class: "warning-logo mr-4 ml-2"
  }),
  /*#__PURE__*/_createElementVNode("span", null, "予約情報をキャンセルしますか?")
], -1))
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p-dialog-content" }, [
  /*#__PURE__*/_createTextVNode("※キャンセル情報は "),
  /*#__PURE__*/_createElementVNode("span", { class: "pink-text" }, "患者様に通知されます。")
], -1))
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p-dialog-content" }, [
  /*#__PURE__*/_createTextVNode("※キャンセル後の予約情報は "),
  /*#__PURE__*/_createElementVNode("span", { class: "pink-text" }, "完全に削除されます。")
], -1))
const _hoisted_70 = { class: "grid mt-5 mb-5 justify-content-center" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center justify-content-center w-100" }, [
  /*#__PURE__*/_createElementVNode("span", null, "予約情報はキャンセルされました。")
], -1))
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p-dialog-content" }, [
  /*#__PURE__*/_createTextVNode("※キャンセル情報は "),
  /*#__PURE__*/_createElementVNode("span", { class: "pink-text" }, "患者様に通知されます。")
], -1))
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p-dialog-content" }, [
  /*#__PURE__*/_createTextVNode("※キャンセル後の予約情報は "),
  /*#__PURE__*/_createElementVNode("span", { class: "pink-text" }, "完全に削除されます。")
], -1))
const _hoisted_74 = { class: "grid mt-5 mb-5 justify-content-center" }
const _hoisted_75 = { class: "d-flex align-items-center" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/images/warning-logo.png",
  alt: "Warning Logo",
  class: "warning-logo mr-4 ml-2"
}, null, -1))
const _hoisted_77 = { class: "p-dialog-content" }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pink-text" }, "患者様に通知されません。", -1))
const _hoisted_79 = { class: "p-dialog-content" }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pink-text" }, "完全に削除されます。", -1))
const _hoisted_81 = { class: "grid mt-5 mb-5 justify-content-center" }
const _hoisted_82 = { class: "d-flex align-items-center justify-content-center w-100" }
const _hoisted_83 = { class: "p-dialog-content" }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pink-text" }, "患者様に通知されません。", -1))
const _hoisted_85 = { class: "p-dialog-content" }
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pink-text" }, "完全に削除されます。", -1))
const _hoisted_87 = { class: "grid mt-5 mb-5 justify-content-center" }

import { onBeforeMount, inject, withDefaults, ref, computed, watch } from "vue";

/**
 * VueUseライブラリからのユーティリティ関数
 * @description リアクティブな状態管理とユーティリティ関数を提供
 */
import { Fn, get, set } from "@vueuse/core";

/**
 * 日付操作ライブラリ
 * @description 日付のフォーマットと操作を提供
 */
import moment from "moment";

/**
 * PrimeVue UIコンポーネント
 * @description ラジオボタンコンポーネント
 */
import RadioButton from "primevue/radiobutton";

/**
 * カスタムコンポーネント
 * @description 編集可能なテキストエリアコンポーネント
 */
import EditableTextareaBooking from "@/clinic/components/atoms/EditableTextareaBooking/index.vue";

/**
 * ユーティリティクラス
 * @description 時間操作のユーティリティ関数
 */
import TimeUtils from "@/clinic/utils/time-utils";

/**
 * サービスクラス
 * @description 予約とメディカルオプション関連のAPI呼び出し
 */
import { BookingServices, MedicalOptionServices } from "@/clinic/services";

/**
 * 型定義
 * @description APIリクエストとレスポンスの型定義
 */
import { ApiBookingShowReq, ApiCommentBookingReq, IBooking } from "@/clinic/typings";

/**
 * 列挙型
 * @description 予約ステータスとページタイプの定数
 */
import { BookingStatusOptions, BookingViewPageTypeEnum, BookingStatusEnum } from "@/clinic/typings/enums/booking";

/**
 * 通知ユーティリティ
 * @description 成功・エラー通知の表示機能
 */
import { notifySuccessMsg, notityErrorMsg } from "@/clinic/utils/notify-utils";

/**
 * Vue Router
 * @description ルーティング機能
 */
import { useRoute } from "vue-router";

/**
 * 数値ユーティリティ
 * @description 通貨フォーマットなどの数値操作
 */
import NumberUtils from "@/clinic/utils/number-utils";

/**
 * PrimeVue Toastサービス
 * @description トースト通知の表示機能
 */
import { ToastServiceMethods } from "primevue/toastservice";

/**
 * FullCalendar関連
 * @description カレンダーイベントの操作
 */
import { EventImpl } from "@fullcalendar/core/internal";
import { EventClickArg } from "@fullcalendar/core";

/**
 * カスタムコンポーネント
 * @description 右サイドバーコンポーネント
 */
import RightSideBar from "@/clinic/views/Customer/components/rightSidebar/RightSideBar.vue";

/**
 * 定数
 * @description 顧客ステータスの定数
 */
import { CustomerStatusesConstants } from "@/clinic/constants/customer.constants";

/**
 * 列挙型
 * @description クリニックパートナーの定数
 */
import { ClinicPartner } from "@/clinic/typings/enums/clinic";

/**
 * Vuexストア
 * @description グローバル状態管理
 */
import { useStore } from "vuex";

/**
 * イベントエミッター
 * @description 親コンポーネントへのイベント通知
 */
type IBodyShowSidebar = {
  booking: IBooking;
  toast: ToastServiceMethods;
  reFetchRemainningSlot: Fn;
  eventArg: EventClickArg;
};

/**
 * ルート情報
 * @type {RouteLocationNormalizedLoaded}
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'body',
  props: {
    booking: { default: () => ({} as IBooking) },
    toast: null,
    reFetchRemainningSlot: null,
    eventArg: { default: () => ({} as EventClickArg) }
  },
  emits: ["close"],
  setup(__props: any, { emit: emits }) {

const props = __props as { booking: IBooking, toast: ToastServiceMethods, reFetchRemainningSlot: Fn, eventArg: EventClickArg };

/**
 * @fileoverview 予約詳細表示コンポーネント
 * 予約情報の詳細表示、ステータス変更、キャンセル、削除機能を提供する
 * @author LineCRM Team
 * @version 1.0.0
 */

// Vue関連のインポート
/**
 * Vue 3 Composition API関連のインポート
 * @description Vue 3のリアクティブシステムとライフサイクルフックを使用
 */


/**
 * 閉じるイベントのハンドラー
 * @returns {void}
 */
const onClose = () => emits("close");

/**
 * ダイアログの表示状態管理
 * @type {Ref<boolean>}
 */
const confirmChangeStatus = ref(false);
const warningVisible = ref(false);
const deleteBookWarningVisible = ref(false);
const deleteBookSuccessVisible = ref(false);
const cancelSuccessVisible = ref(false);

/**
 * クリニックID
 * @type {Ref<number>}
 */
const clinicId = ref(0);

/**
 * 選択されたリクエストID
 * @type {Ref<number>}
 */
const requestId = ref();

/**
 * ダイアログの表示状態
 * @type {Ref<boolean>}
 */
const dialogVisible = ref(false);

/**
 * 選択されたステータス
 * @type {Ref<string>}
 */
const selectedStatus = ref("");

/**
 * サイドバーの表示状態
 * @type {Ref<boolean>}
 */
const visibleSideBar = ref(false);

/**
 * 更新タイプ（今回のみ/今回と次回以降）
 * @type {Ref<string>}
 */
const updateType = ref("update_only_this");

/**
 * サイドバーの参照
 * @type {Ref<RightSideBar | null>}
 */
const sidebar = ref<InstanceType<typeof RightSideBar> | null>(null);

/**
 * Vuexストア
 * @type {Store}
 */
const store = useStore();

/**
 * コンポーネントのプロパティ型定義
 * @typedef {Object} IBodyShowSidebar
 * @property {IBooking} booking - 予約情報
 * @property {ToastServiceMethods} toast - トースト通知サービス
 * @property {Fn} reFetchRemainningSlot - 残りスロット再取得関数
 * @property {EventClickArg} eventArg - カレンダーイベント引数
 */
const route = useRoute();

/**
 * コンポーネントのプロパティ
 * @type {IBodyShowSidebar}
 */


/**
 * メディカルオプションのリスト
 * @type {Ref<any[]>}
 */
const medicalOptions = ref<any[]>([]);

/**
 * 予約ステータス
 * @type {Ref<string>}
 */
const bookingStatus = ref(props.booking.status);

/**
 * フルアクションの表示フラグ
 * @type {Ref<boolean>}
 */
const showFullActions = ref(true);

/**
 * メニュー名の計算プロパティ
 * @description メインメニューと追加メニューの名前を結合
 * @type {ComputedRef<string>}
 */
const medicalMenuNames = computed(() => {
  const medicalMenuName = props.booking.medical_menu?.name;
  const additionalMenuNames = props.booking.additional_menus?.map(menu => menu.name) || [];
  return [medicalMenuName, ...additionalMenuNames].join("\n");
});

/**
 * サイドバーを表示する
 * @async
 * @returns {Promise<void>}
 */
const onShowSidebar = async () => {
  await get(sidebar)?.onShow();
};

/**
 * 予約メモを編集する
 * @async
 * @param {number} id - 予約ID
 * @param {string} comment - コメント内容
 * @returns {Promise<void>}
 */
const onEditing = async (id: number, comment: string): Promise<void> => {
  await BookingServices.saveComment({ id } as ApiBookingShowReq, { comment } as unknown as ApiCommentBookingReq);
  const event = get(props.eventArg)?.event as EventImpl;
  event.source?.refetch();
};

/**
 * ステータス変更を処理する
 * @param {string} status - 新しいステータス
 * @returns {void}
 */
const handleChangeStatus = (status: string) => {
  set(selectedStatus, status);
  set(confirmChangeStatus, true);
};

/**
 * ステータス変更を確定する
 * @returns {void}
 */
const processChangeStatus = () => {
  set(confirmChangeStatus, false);
  const { booking_type } = props.booking;

  booking_type == "repeat" ? set(dialogVisible, true) : onChangingStatus(get(selectedStatus), "normal");
};

/**
 * Hotpepper予約を確認する
 * @async
 * @returns {Promise<void>}
 */
const onConfirmHotpepper = async () => {
  const { id } = props.booking;
  const clinicIdValue = get(get(clinicId)) as number;
  const bookingRequest = { id, clinic_id: clinicIdValue } as ApiBookingShowReq;
  await BookingServices.confirmHotpepper(bookingRequest, () => {
    set(showFullActions, true);
    notifySuccessMsg(get(props.toast), "保存成功");
    reloadEvents();
    props.reFetchRemainningSlot();
  });
  document.querySelectorAll(".btn-change-status").forEach(element => element.classList.remove("btn-selected"));
  document.querySelectorAll("button[data-status='will_come']")[0].classList.add("btn-selected");
};

/**
 * ステータス変更を実行する
 * @async
 * @param {string} newStatus - 新しいステータス
 * @param {string} changeStatusType - 変更タイプ
 * @returns {Promise<void>}
 */
const onChangingStatus = async (newStatus: string, changeStatusType: string) => {
  const { id } = props.booking;
  const clinicIdValue = get(get(clinicId)) as number;

  const successCallback = () => {
    notifySuccessMsg(get(props.toast), "保存成功");
    reloadEvents();
    onClose();
    props.reFetchRemainningSlot();
  };

  const errorCallback = (errors: any) => {
    notityErrorMsg(get(props.toast), errors.response.data.errors || errors.response.data.error);
  };
  const statusRequest = { status: newStatus };

  if (changeStatusType == "update_this_and_following") {
    const { customer, medical_menu, staff, menu_name, status, ...rest } = props.booking;
    const bookingRequest = { ...rest, clinic_id: clinicIdValue, id };
    BookingServices.saveBatchStatus(bookingRequest, statusRequest, successCallback, errorCallback);
  } else {
    const bookingRequest = { id, clinic_id: clinicIdValue } as ApiBookingShowReq;
    BookingServices.saveStatus(bookingRequest, statusRequest, successCallback, errorCallback);
  }
  onCloseDialog();
};

/**
 * 顧客予約を削除する
 * @async
 * @returns {Promise<void>}
 */
const deleteCustomerBooking = async () => {
  try {
    const booking_id = props.booking?.id;
    const clinic_id = get(get(clinicId));
    await BookingServices.deleteBooking(
      Number(booking_id),
      clinic_id,
      "customer",
      () => {
        // noop
      },
      () => {
        // noop
      }
    );
    cancelSuccessVisible.value = true;
    reloadEvents();
    onClose();
  } catch (error) {
    notityErrorMsg(get(props.toast), "実行中に未処理のエラーが発生しました。もう一度試してください。");
  }
};

/**
 * クリニック予約を削除する
 * @async
 * @returns {Promise<void>}
 */
const deleteClinicBooking = async () => {
  try {
    const booking_id = props.booking?.id;
    const clinic_id = get(get(clinicId));
    await BookingServices.deleteBooking(
      Number(booking_id),
      clinic_id,
      "clinic",
      () => {
        // noop
      },
      () => {
        // noop
      }
    );
    deleteBookSuccessVisible.value = true;
    if (props.booking?.booking_type == "request") {
      const storeValues = { booking_id: booking_id };
      store.commit("booking/setNotificationsBookingRequests", storeValues);
    }
    reloadEvents();
    onClose();
  } catch (error) {
    notityErrorMsg(get(props.toast), "実行中に未処理のエラーが発生しました。もう一度試してください。");
  }
};

/**
 * 警告ダイアログを閉じる
 * @returns {void}
 */
const onClosedWarningDialog = () => {
  warningVisible.value = false;
  cancelSuccessVisible.value = false;
};

/**
 * 削除警告ダイアログを閉じる
 * @returns {void}
 */
const onClosedDeleteBookingWarningDialog = () => {
  deleteBookWarningVisible.value = false;
  deleteBookSuccessVisible.value = false;
};

/**
 * 削除成功ダイアログを閉じる
 * @returns {void}
 */
const onDialogDeleteSuccessClose = () => {
  reloadEvents();
  onClose();
  deleteBookSuccessVisible.value = false;
};

/**
 * ダイアログを閉じる
 * @returns {void}
 */
const onDialogClose = () => {
  reloadEvents();
  onClose();
  cancelSuccessVisible.value = false;
};

/**
 * リクエストを承認する
 * @async
 * @param {number} bookingId - 予約ID
 * @returns {Promise<void>}
 */
const handleApproveRequest = async (bookingId: number) => {
  await BookingServices.approveRequest(
    bookingId,
    requestId.value,
    get(get(clinicId)),
    () => {
      reloadEvents();
      onClose();
      notifySuccessMsg(get(props.toast), "保存成功");
      props.reFetchRemainningSlot();
      const storeValues = { booking_id: bookingId };
      store.commit("booking/setNotificationsBookingRequests", storeValues);
    },
    () => {
      notityErrorMsg(get(props.toast), "見つかりません");
    }
  );
};

/**
 * ダイアログを閉じる
 * @returns {void}
 */
const onCloseDialog = () => {
  set(selectedStatus, "");
  set(dialogVisible, false);
};

/**
 * イベントを再読み込みする
 * @returns {void}
 */
const reloadEvents = () => {
  if (route.query.view_page !== BookingViewPageTypeEnum.List) {
    const event = get(props.eventArg)?.event as EventImpl;
    if (event) {
      event._context.calendarApi.removeAllEvents();
      event._context.calendarApi.refetchEvents();
    }
  }
};

/**
 * オプションを取得する
 * @async
 * @returns {Promise<void>}
 */
const fetchOptions = async () => {
  const ids = props.booking?.medical_option_ids;
  if (!ids || ids.length == 0) {
    set(medicalOptions, []);
    return;
  }

  const { data } = await MedicalOptionServices.getOptions(
    { ids, clinic_id: get(await get(clinicId)) },
    () => undefined,
    err => err
  );
  set(medicalOptions, (get(data) as any)?.options);
};

/**
 * コンポーネントマウント前の初期化処理
 * @async
 * @returns {Promise<void>}
 */
onBeforeMount(async () => {
  set(clinicId, await inject("clinicId"));
  set(requestId, props.booking?.booking_requests?.[0]?.id);
  const showAll = !(
    props.booking.booking_source == "hotpepper" &&
    props.booking.status == "will_come" &&
    props.booking.hotpepper_confirmed == false
  );
  set(showFullActions, showAll);
  await fetchOptions();
});

// 予約データが変更された際にオプションを再取得
watch(
  () => props.booking?.medical_option_ids,
  async (newIds, oldIds) => {
    if (newIds !== oldIds) {
      await fetchOptions();
    }
  },
  { deep: true }
);

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_Toast = _resolveComponent("Toast")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(RightSideBar, {
      ref_key: "sidebar",
      ref: sidebar,
      visible: visibleSideBar.value,
      "customer-id": props.booking?.customer_id || 0,
      "account-id": 0,
      "clinic-id": _unref(get)(clinicId.value)
    }, null, 8, ["visible", "customer-id", "clinic-id"]),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("p", _hoisted_5, [
            _createTextVNode(_toDisplayString(props.booking?.customer?.name || props.booking?.customer_name) + " ", 1),
            _hoisted_6,
            _createElementVNode("span", {
              class: _normalizeClass(["inline-block customer-status border-round-xl text-center mr-1 px-2 mt-1", props.booking?.customer?.status])
            }, _toDisplayString(props.booking?.customer_status_display_name ||
              (_unref(CustomerStatusesConstants) as any)[props.booking?.customer?.status]), 3)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_Button, {
            label: "顧客詳細",
            class: "btn-white",
            onClick: onShowSidebar
          })
        ])
      ]),
      _hoisted_8,
      _createElementVNode("div", _hoisted_9, _toDisplayString(props.booking?.customer?.name_kana), 1),
      _hoisted_10,
      _createElementVNode("div", _hoisted_11, _toDisplayString(props.booking?.customer?.code), 1),
      _hoisted_12,
      _createElementVNode("div", _hoisted_13, _toDisplayString(props.booking?.customer?.phone), 1),
      (props.booking?.start_time && props.booking?.end_time)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _hoisted_14,
            _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(TimeUtils).formatRangeDateTime(
            new Date(_unref(TimeUtils).toLocalTime(props.booking?.start_time.toString())),
            new Date(_unref(TimeUtils).toLocalTime(props.booking?.end_time.toString()))
          )), 1)
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _hoisted_16,
            _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(moment)(props.booking?.created_at?.toString()).format("YYYY/MM/DD HH:mm:ss")), 1)
          ], 64)),
      _hoisted_18,
      _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(medicalMenuNames)), 1),
      (showFullActions.value && !props.booking?.is_free_space)
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, "部屋・設備予約名"))
        : _createCommentVNode("", true),
      (showFullActions.value && !props.booking?.is_free_space)
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(props.booking?.room?.name), 1))
        : _createCommentVNode("", true),
      _hoisted_22,
      _createElementVNode("div", _hoisted_23, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(medicalOptions.value, (option) => {
          return (_openBlock(), _createElementBlock("div", {
            key: option.id,
            class: "flex align-items-center"
          }, [
            _createElementVNode("div", null, _toDisplayString(option.name), 1)
          ]))
        }), 128))
      ]),
      _hoisted_24,
      _createElementVNode("div", _hoisted_25, _toDisplayString(_unref(NumberUtils).formatJPCurrency(parseInt(props.booking?.total_amount), "")) + "円", 1),
      _hoisted_26,
      _createElementVNode("div", _hoisted_27, _toDisplayString(props.booking?.additional_fees
          ? _unref(NumberUtils).formatJPCurrency(parseInt((props.booking?.additional_fees as any)["nomination_fee"]), "") + `円`
          : ""), 1),
      _hoisted_28,
      _createElementVNode("div", _hoisted_29, _toDisplayString(props.booking?.staff_name), 1),
      _hoisted_30,
      _createElementVNode("div", _hoisted_31, [
        (props.booking?.status == 'will_come')
          ? (_openBlock(), _createBlock(EditableTextareaBooking, {
              key: 0,
              customerId: Number(props.booking?.id),
              comment: `${props.booking?.note || ''}`,
              onClick: (customerId, comment) => { onEditing(customerId, comment); return undefined; },
              disabled: _unref(store).getters['authClient/selectedClinic'].partner != _unref(ClinicPartner).Unaffiliated
            }, null, 8, ["customerId", "comment", "onClick", "disabled"]))
          : _createCommentVNode("", true)
      ]),
      _hoisted_32,
      _createElementVNode("div", _hoisted_33, [
        _createElementVNode("span", null, _toDisplayString(props.booking?.note_symptom), 1)
      ]),
      _hoisted_34,
      _createElementVNode("div", _hoisted_35, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.booking.special_notes, (note, index) => {
          return (_openBlock(), _createElementBlock("p", {
            class: "special-note white-space-normal m-0 mb-2 text-sm",
            key: index
          }, _toDisplayString(index + 1) + ". " + _toDisplayString(note.content), 1))
        }), 128))
      ]),
      (!(props.booking?.start_time && props.booking?.end_time))
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
            _hoisted_36,
            _createElementVNode("div", _hoisted_37, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.booking?.booking_requests, (request) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "flex align-items-center mb-2 radio-wrapper__custom",
                  key: request.id
                }, [
                  _createVNode(_unref(RadioButton), {
                    modelValue: requestId.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((requestId).value = $event)),
                    disabled: props.booking?.status != 'will_come',
                    inputId: `request-${request.id}`,
                    value: request.id
                  }, null, 8, ["modelValue", "disabled", "inputId", "value"]),
                  _createElementVNode("label", {
                    for: `request-${request.id}`,
                    class: _normalizeClass(["flex ml-2 align-items-center", {
              'text-orange': requestId.value == request.id,
              'p-radio-disabled': props.booking?.status != 'will_come',
            }])
                  }, [
                    (requestId.value == request.id)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_39))
                      : (_openBlock(), _createElementBlock("span", _hoisted_40)),
                    _createTextVNode(" 第" + _toDisplayString(request.priority + 1) + "希望日: " + _toDisplayString(_unref(moment)(_unref(TimeUtils).toLocalTime(request.start_time)).format("YYYY/MM/DD HH:mm")), 1)
                  ], 10, _hoisted_38)
                ]))
              }), 128))
            ])
          ], 64))
        : _createCommentVNode("", true)
    ]),
    (_unref(store).getters['authClient/selectedClinic'].partner == _unref(ClinicPartner).Unaffiliated)
      ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
          (showFullActions.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_42, _hoisted_44))
            : _createCommentVNode("", true),
          (props.booking?.start_time && props.booking?.end_time)
            ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                (showFullActions.value)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(BookingStatusOptions), (item) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: item.value,
                        class: "w-6 p-1"
                      }, [
                        _createVNode(_component_Button, {
                          label: item.name,
                          class: _normalizeClass(["btn-change-status p-button-light border-round-3xl w-full", {
              'btn-selected': bookingStatus.value == item.value && !(props.booking as any)?.canceled_by_customer_request,
              'p-disabled': props.booking?.status != 'will_come',
            }]),
                          "data-status": item.value,
                          onClick: ($event: any) => (handleChangeStatus(item.value))
                        }, null, 8, ["label", "class", "data-status", "onClick"])
                      ]))
                    }), 128))
                  : (_openBlock(), _createElementBlock("div", _hoisted_46, [
                      _createVNode(_component_Button, {
                        label: "確認する",
                        class: "btn-change-status p-button-light border-round-3xl mr-2 mb-2 btn-confirm-hotpepper w-6 mt-4",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (onConfirmHotpepper()))
                      })
                    ]))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_47, [
                (showFullActions.value && !props.booking?.is_free_space)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                      _createVNode(_component_Button, {
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (handleApproveRequest(Number(props.booking.id)))),
                        class: _normalizeClass(["sidebar-btn primary-btn justify-content-center font-bold w-100 mr-2", { 'p-disabled': props.booking?.status != 'will_come' }])
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" リクエストを承認 ")
                        ]),
                        _: 1
                      }, 8, ["class"])
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_49
              ])),
          (_unref(store).getters['authClient/selectedClinic'].partner == _unref(ClinicPartner).Unaffiliated)
            ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                (showFullActions.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_51, _hoisted_53))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_54, [
                  (showFullActions.value && !props.booking?.is_free_space)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                        _createVNode(_component_Button, {
                          class: _normalizeClass(["btn-change-status p-button-light border-round-3xl mr-2 mb-2 sidebar-btn font-bold w-100 justify-content-center", {
              'p-disabled': props.booking?.status != 'will_come',
              'btn-selected': (props.booking as any)?.canceled_by_customer_request,
            }]),
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (warningVisible.value = true))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" 予約キャンセル ")
                          ]),
                          _: 1
                        }, 8, ["class"])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_56, [
                    _createVNode(_component_Button, {
                      class: _normalizeClass(["sidebar-btn orange-btn font-bold w-100 justify-content-center", { 'p-disabled': props.booking?.status != 'will_come' }]),
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (deleteBookWarningVisible.value = true))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(props.booking?.is_free_space ? "自由予約情報削除" : "予約情報削除"), 1)
                      ]),
                      _: 1
                    }, 8, ["class"])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_Dialog, {
      visible: confirmChangeStatus.value,
      "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((confirmChangeStatus).value = $event)),
      modal: "",
      style: { width: '550px' },
      class: "mx-5 dialog-note border-0"
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_57, [
          _hoisted_58,
          _createElementVNode("span", null, [
            _createTextVNode(" 来店ステータスを「 "),
            _createElementVNode("span", _hoisted_59, _toDisplayString(_unref(BookingStatusEnum)[selectedStatus.value as keyof typeof BookingStatusEnum]), 1),
            _createTextVNode(" 」に変更確定しますか？ ")
          ])
        ])
      ]),
      default: _withCtx(() => [
        _hoisted_60,
        _createElementVNode("div", _hoisted_61, [
          _createVNode(_component_Button, {
            class: "col-4 black-btn ml-5",
            label: "キャンセル",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (confirmChangeStatus.value = false))
          }),
          _createVNode(_component_Button, {
            class: "col-4 delete-btn ml-5",
            label: "確定",
            onClick: processChangeStatus
          })
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Dialog, {
      visible: dialogVisible.value,
      "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((dialogVisible).value = $event)),
      modal: "",
      header: "定期予約のステータスを変更する",
      draggable: false,
      style: { width: '400px' }
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_62, [
          _createVNode(_unref(RadioButton), {
            inputId: "only-this",
            name: "update_type",
            modelValue: updateType.value,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((updateType).value = $event)),
            value: "update_only_this",
            required: true
          }, null, 8, ["modelValue"]),
          _hoisted_63
        ]),
        _createElementVNode("div", _hoisted_64, [
          _createVNode(_unref(RadioButton), {
            inputId: "this_and_following",
            name: "update_type",
            modelValue: updateType.value,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((updateType).value = $event)),
            value: "update_this_and_following",
            required: true
          }, null, 8, ["modelValue"]),
          _hoisted_65
        ]),
        _createElementVNode("div", _hoisted_66, [
          _createVNode(_component_Button, {
            label: "キャンセル",
            class: "p-button-light mr-5",
            onClick: onCloseDialog
          }),
          _createVNode(_component_Button, {
            label: "保存",
            class: "text-white",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (onChangingStatus(selectedStatus.value, updateType.value)))
          })
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Dialog, {
      visible: warningVisible.value,
      "onUpdate:visible": _cache[11] || (_cache[11] = ($event: any) => ((warningVisible).value = $event)),
      modal: "",
      style: { width: '550px' },
      class: "mx-5 dialog-note border-0"
    }, {
      header: _withCtx(() => [
        _hoisted_67
      ]),
      default: _withCtx(() => [
        _hoisted_68,
        _hoisted_69,
        _createElementVNode("div", _hoisted_70, [
          _createVNode(_component_Button, {
            class: "col-4 black-btn ml-5",
            label: "戻る",
            onClick: onClosedWarningDialog
          }),
          _createVNode(_component_Button, {
            class: "col-4 cancel-btn ml-5",
            label: "キャンセル実行",
            onClick: deleteCustomerBooking
          })
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Dialog, {
      visible: cancelSuccessVisible.value,
      "onUpdate:visible": _cache[12] || (_cache[12] = ($event: any) => ((cancelSuccessVisible).value = $event)),
      onHide: onDialogClose,
      modal: "",
      header: '予約情報はキャンセルされました。',
      style: { width: '550px' },
      class: "mx-5 dialog-note border-0"
    }, {
      header: _withCtx(() => [
        _hoisted_71
      ]),
      default: _withCtx(() => [
        _hoisted_72,
        _hoisted_73,
        _createElementVNode("div", _hoisted_74, [
          _createVNode(_component_Button, {
            class: "col-4 black-btn ml-5",
            label: "戻る",
            onClick: onDialogClose
          })
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Dialog, {
      visible: deleteBookWarningVisible.value,
      "onUpdate:visible": _cache[13] || (_cache[13] = ($event: any) => ((deleteBookWarningVisible).value = $event)),
      modal: "",
      style: { width: '550px' },
      class: "mx-5 dialog-note border-0"
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_75, [
          _hoisted_76,
          _createElementVNode("span", null, _toDisplayString(props.booking?.is_free_space ? "自由予約情報を削除しますか?" : "予約情報を削除しますか?"), 1)
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("p", _hoisted_77, [
          _createTextVNode(" ※" + _toDisplayString(props.booking?.is_free_space ? "自由予約情報削除" : "予約情報削除") + "は ", 1),
          _hoisted_78
        ]),
        _createElementVNode("p", _hoisted_79, [
          _createTextVNode(" ※削除実行後の" + _toDisplayString(props.booking?.is_free_space ? "自由予約情報" : "予約情報") + "は ", 1),
          _hoisted_80
        ]),
        _createElementVNode("div", _hoisted_81, [
          _createVNode(_component_Button, {
            class: "col-4 black-btn ml-5",
            label: "戻る",
            onClick: onClosedDeleteBookingWarningDialog
          }),
          _createVNode(_component_Button, {
            class: "col-4 delete-btn ml-5",
            label: "削除する",
            onClick: deleteClinicBooking
          })
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Dialog, {
      visible: deleteBookSuccessVisible.value,
      "onUpdate:visible": _cache[14] || (_cache[14] = ($event: any) => ((deleteBookSuccessVisible).value = $event)),
      onHide: onDialogDeleteSuccessClose,
      modal: "",
      style: { width: '550px' },
      class: "mx-5 dialog-note border-0"
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_82, [
          _createElementVNode("span", null, _toDisplayString(props.booking?.is_free_space ? "自由予約情報が削除されました。" : "予約情報が削除されました。"), 1)
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("p", _hoisted_83, [
          _createTextVNode(" ※" + _toDisplayString(props.booking?.is_free_space ? "自由予約情報削除" : "予約情報削除") + "は ", 1),
          _hoisted_84
        ]),
        _createElementVNode("p", _hoisted_85, [
          _createTextVNode(" ※削除実行後の" + _toDisplayString(props.booking?.is_free_space ? "自由予約情報" : "予約情報") + "は ", 1),
          _hoisted_86
        ]),
        _createElementVNode("div", _hoisted_87, [
          _createVNode(_component_Button, {
            class: "col-4 black-btn ml-5",
            label: "戻る",
            onClick: onDialogDeleteSuccessClose
          })
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Toast, { position: "top-center" })
  ], 64))
}
}

})